import { Component, Inject, OnInit, Optional } from '@angular/core';

import { RESPONSE } from '@nguniversal/express-engine/tokens';
import type { Response } from 'express';

import { EventsService, SeoService } from '@app/core/services';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
})
export class PageNotFoundComponent implements OnInit {
  constructor(
    @Optional() @Inject(RESPONSE) private response: Response,
    private seoService: SeoService,
    private eventService: EventsService,
  ) {}

  ngOnInit(): void {
    this.response?.status(404);
    this.seoService.setIndexOff();
    this.eventService.setHideMap(true);
    this.eventService.setIsFirstLoading(false);
    this.eventService.setIsLoading(false);
  }
}
